import { useEffect, useState } from "react";
import { Loader2, Inbox } from "lucide-react";
import { adminApi } from "@/lib/adminApi";

export const InquiriesPanel = () => {
  const [inquiries, setInquiries] = useState(null);

  useEffect(() => {
    adminApi
      .get("/inquiries")
      .then((r) => setInquiries(r.data))
      .catch(() => setInquiries([]));
  }, []);

  if (!inquiries)
    return (
      <div className="flex items-center gap-2 text-[#5B6F64] py-12">
        <Loader2 size={18} className="animate-spin" /> Loading inquiries…
      </div>
    );

  if (inquiries.length === 0)
    return (
      <div data-testid="inquiries-empty" className="flex flex-col items-center gap-3 text-[#5B6F64] py-16">
        <Inbox size={32} strokeWidth={1.2} />
        <p className="font-light">No inquiries yet.</p>
      </div>
    );

  return (
    <div data-testid="inquiries-panel" className="space-y-4">
      <p className="text-sm text-[#5B6F64]">{inquiries.length} inquiries</p>
      {inquiries.map((inq) => (
        <div
          key={inq.id}
          data-testid={`inquiry-${inq.id}`}
          className="bg-white border border-[#122A1D]/10 p-6"
        >
          <div className="flex flex-wrap items-baseline justify-between gap-2 mb-2">
            <p className="font-heading text-xl text-[#122A1D]">
              {inq.name}
              <span className="font-body text-sm text-[#8C6A1F] ml-3">{inq.email}</span>
            </p>
            <p className="text-xs text-[#5B6F64]">
              {new Date(inq.created_at).toLocaleString()}
              {inq.service && (
                <span className="ml-3 uppercase tracking-wider border border-[#C8A24A]/40 text-[#A9842F] px-2 py-0.5">
                  {inq.service}
                </span>
              )}
            </p>
          </div>
          <p className="text-[#44584C] font-light text-sm leading-relaxed whitespace-pre-wrap">{inq.message}</p>
        </div>
      ))}
    </div>
  );
};
